import { PageResource, pageResource } from '@witkac/kartamiejska-resources';
import { Page } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł stron
 *
 * @export
 * @class PagesModule
 * @extends {EntityModule<Page, PageResource>}
 */
export class PagesModule extends EntityModule<Page, PageResource> {
  constructor() {
    super(pageResource);
    this.actions = {
      ...this.actions,

      /**
       * Dodaje stronę
       *
       * @param {*} context
       * @param {*} data
       */
      add: async (context: any, data: any) => {
        data.page.id = await this.resource.add(data);
        context.commit('add', data.page);
        context.commit('incrementCount');
      },
      /**
       * Aktualizuje stronę
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: async (context: any, data: any) => {
        data.page.id = await this.resource.update(data.id, data);
        context.commit('update', data.page);
        context.commit('setEntity', data.page);
      }
    };
  }
}

export default new PagesModule();
